import { ColorOptions, FontSizeOptions, IconNewOptions } from '@jfs/ui-new'
import { FontWeightOptions } from '@jfs/ui-new/src/theme/UiThemeProvider'

export enum DropdownTypes {
  DEFAULT_WITH_IMAGE = 'Default',
  RADIO_BUTTON = 'RadioButton',
  DEFAULT_WITHOUT_BORDER = 'defaultWithoiutBorder',
  SELECTABLE_HIGHLIGHT = 'selectableHighlight',
  DEFAULT_WITH_BG = 'defaultWithBg',
  DEFAULT_DOWNLOAD_REPORT = 'DownloadReportType',
  ADD_BENEFICIARY = 'AddBeneficiary',
}

type FontWeightValues = 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900'
export interface DropDownProps {
  type?: DropdownTypes
  placeHolder: string
  onChange: (value: number[] | string, position?: { left: number; top: number }) => void
  data: any
  fieldName?: string
  setFieldValue?: (field: string, value: string | number) => void
  hide?: boolean
  onButtonPress?: (fileFormatType: string) => void
  buttonLabel?: string
  showBorder?: boolean
  iconType?: IconNewOptions | null
  title?: string
  dropDownContentFontSize?: FontSizeOptions | number
  chevronColor?: ColorOptions
  dropdownWidth?: number
  label?: string
  allValues?: any
  value?: any
  disabled?: boolean
  disabledBg?: ColorOptions
  error?: string
  touched?: boolean
  labelColor?: ColorOptions
  toolTipInfo?: string
  borderColor?: ColorOptions
  testID?: string
  buttonWidth?: number | undefined | string
  titleColor?: ColorOptions
  labelFontFamily?: any
  labelPaddingBottom?: number
  boxheight?: number
  fontWeight?: FontWeightOptions | FontWeightValues | Array<FontWeightOptions | FontWeightValues>
  dropdownHeight?: number
}

export interface itemSelected {
  id: number
  value: string
}

export interface DropDownBoxInterface {
  showBorder?: boolean
  isIconAvailable?: boolean
  onLayout?: (value: Object) => void
  toggleDropdown: (val: boolean) => void
  iconType?: IconNewOptions
  defaultLabel: string
  dropdownVisible: boolean
  type: DropdownTypes
  value: string
  clearSelection: () => void
  disabled?: boolean
  disabledBg?: ColorOptions
  chevronColor?: ColorOptions
  borderColor?: ColorOptions
  buttonWidth?: number | undefined | string
  testID?: string
  titleColor?: ColorOptions
  fontWeight: FontWeightOptions | FontWeightValues | Array<FontWeightOptions | FontWeightValues>
}
